export default {
  lang: {
    title: {
      login: 'Login',
      quickQuery: 'Application Search',
      ssoCallback: 'Please wait...',
      confirmInfo: 'Personal Information',
      confirmPack: 'Choose the required document',
      confirmReceiveInfo: '请选择领取方式',
      submit: 'Submit application',
      applyList: 'Application search',
      applyDetail: 'Application detail'
    },
    common: {
      chooseDate: 'Choose Date',
      pleaseSelect: 'Please Select',
      uploadFile: 'Upload File',
      yes: 'Yes',
      no: 'No',
      uploadAttachment: 'Upload Attachment',
      cny: 'CNY',
      usd: 'USD',
      goNext: 'Next',
      goBack: 'Prev',
      uploadTip: 'Drop file here or click to upload',
      notice: 'Notice',
      remark: 'Remark',
      query: 'Search',
      confirmUpload: 'Confirm Upload',
      warning: 'Warning',
      back: 'Back',
      uploadSuccess: 'Upload Success!'
    },
    toast: {
      serverInternalError: 'Server Internal Error, Please Retry or Contact Administrator',
      urlNotFound: 'Url Error, Please Retry or Contact Administrator',
      requestError: 'Request Error, Please Retry or  Contact Administrator',
      applyAlreadySubmit: 'Current Application is Already Submitted, Do You Want to Apply Again?',
      operationSuccess: 'Success',
      applyAlreadyCancelled: 'Current Application is Already Cancelled, Please Apply Again'
    },
    loginPage: {
      ceibsStudentCert: 'Transcript and Certificate Online Application System',
      wantToApply: 'Apply',
      useCeibsAccount: 'CEIBS Account Login',
      quickApply: 'Forgot CEIBS Account, Apply Here',
      systemNotice: 'Notice',
      applyQuery: 'Application Search',
      inputYourId: 'ID Card/Passport',
      inputApplyNo: 'Application No',
      or: 'OR',
      query: 'Query',
      youHaveUnFinishedApply: 'You have a unfinished Application, continue?',
      login: 'LOGIN',
      createNewApply: 'New Application',
      logout: 'Logout',
      pleaseInputYourIdNo: 'Please Input Your Id/Passport No.',
      pleaseInputYourApplicationNo: 'Please Input Your Application No.'
    },
    confirmInfo: {
      pleaseConfirmYourInfo: 'Personal Information',
      name: 'Name',
      email: 'Email',
      studentNo: 'Student Number/Enrollment Year',
      mobile: 'Mobile Phone',
      birthday: 'Birth Date',
      idType: 'Type of ID',
      gender: 'Gender',
      idNo: 'ID Number',
      passportNo: 'Passport Number',
      course: 'Programme',
      currentStatus: 'Status with School',
      applyType: 'Application Type',
      applyPurpose: 'Application Purpose',
      idPhoto: 'Scanned Copy of ID Card',
      idTypes: {
        idCard: 'ID Card',
        passport: 'Passport'
      },
      genders: {
        male: 'Male',
        female: 'Female'
      },
      applyTypes: {
        paper: 'Paper',
        electronic: 'Electronic'
      },
      upload: {
        pleaseUploadImage: 'Please Upload Image Format Files(jpg/jpeg/png)',
        btn: 'Upload',
        previewBtn: 'Preview'
      },
      validate: {
        name: 'Please Input Your Name',
        email: 'Please Input Your Email',
        studentNo: 'Please Input Your Student Number',
        mobile: 'Please Input Your Mobile Phone',
        birthday: 'Please Choose Your Birth Date',
        idType: 'Please Choose Your Type of ID',
        idNo: 'Please Input Your ID Number',
        gender: 'Please Choose Your Gender',
        courseId: 'Please Choose Your Programme',
        studentStatus: 'Please Choose Your Status with School',
        applyType: 'Please Choose your Application Type',
        pleaseUploadIdPhoto: 'Please Upload Your Scanned Copy of ID Card'
      }
    },
    chooseCert: {
      wantToApply: 'I want to apply',
      chooseCert: 'Choose the required document',
      choosePackage: 'Choose Package',
      totalAmount: 'Total',
      certName: 'Document Type',
      needUploadAttachment: 'Attachment required',
      amount: 'Number of copies',
      price: 'Price',
      sumAmount: 'Total',
      standardCert: 'Standard Document',
      nonStandardCert: 'Non-Standard Document',
      diplomaCert: 'Degree Certificate',
      needElectronicVersion: 'Electronic copy required',
      addPackage: 'Add Package',
      removePackage: 'Delete Package',
      needSeal: 'Request for sealed transcript',
      package: 'Package',
      certType: 'Certificate Type',
      remainCopyNumber: 'Remaining copies allowed',
      confirmDeletePackage: 'Confirm Delete Package',
      sealCharge: 'Sealing fees：CNY ',
      validate: {
        atLeastOneCert: 'Please At Least Choose a Certificate',
        pleaseUploadAttachmentFor: 'Please At Least Upload One Attachment For: ',
        pleaseAssignRemainCopyNumber: 'Please Assign Remain Copies Of：'
      },
      addPackageTooltip: 'Please add a packaging if you need to pick-up separately or have the documents couriered to different addresses'
    },
    confirmReceiveInfo: {
      wantToApply: 'Apply',
      chooseReceiveType: 'How to Pick-Up',
      package: 'Package',
      receiveType: {
        onsite: 'Pick-Up onsite',
        entrustOnsite: 'Pick-Up by authorization party',
        expressMail: 'Send by courier'
      },
      expressMailCharge: 'Express Cost CNY：',
      detail: 'Detail',
      expectedReceiveTime: 'Expected Pick-Up Date',
      expectedReceiveTimeTips: 'Please choose working days, national or school holidays are not available',
      downloadEntrustTemplate: 'Download Authorization Letter template',
      name: 'Assignee',
      relation: 'Relationship With The Applicant',
      phoneNumber: 'Tel./Mobile',
      mailConsignee: 'Consignee Name',
      mailConsigneePhone: 'Consignee Phone',
      mailAreaType: 'Mailing Area',
      mainland: 'Chinese Mainland',
      hkMacaoTw: 'Hong Kong, Macao and Taiwan',
      international: 'Overseas',
      mailArea: 'Country/Region',
      city: 'City',
      mailZipCode: 'Zip Code',
      mailAddress: 'Address',
      needExpedite: 'Rush Order',
      expediteDesc: {
        part1: 'RMB ',
        part2: '(or USD ',
        part3: ') per Rush Order. Commonly takes ',
        part4: ' working days, while taking ',
        part5: ' working day on rush order.'
      },
      entrustRemark: 'Information of assignee for identity check (optional)',
      certType: 'Certificate Type',
      certName: 'Certificate Name',
      quantity: 'Copies',
      chargeAmount: 'Charge',
      validate: {
        pleaseChooseExpectedReceiveTime: 'Please Choose Expected Pick-Up Date',
        expectedReceiveTimeTooEarly: 'Expected Pick-Up Date should not earlier than：',
        mailConsignee: 'Please Input Consignee Name',
        mailConsigneePhone: 'Please Input Consignee Phone',
        mailAreaType: 'Please Select Mailing Area',
        mailArea: 'Please Input Country/Region',
        mailCity: 'Please Input City',
        mailAddress: 'Please Input Address'
      }
    },
    submit: {
      wantToApply: 'I want to apply',
      submitApply: 'Submit Apply',
      sumAmount: 'Total',
      cnyRmb: 'CNY',
      usdDollar: 'USD',
      chargeDetail: 'Details',
      applyNo: 'Application No.',
      ceibsBankAccount: 'CEIBS Bank Account',
      payType: 'Mode of Payment',
      bankTransfer: 'Bank Transfer',
      cash: 'Cash Pay',
      onlinePay: 'Online Pay',
      needReceipt: 'Receipt required',
      pleaseInputReceiptTitle: 'Please Provide the Title of the Receipt',
      doSubmit: 'Submit',
      onlinePaySuccessOrNot: 'Online Payment Success or Failure',
      submitSuccess: 'Apply Success',
      uploadBankTransferVoucher: 'Upload Voucher of Bank Transfer',
      checkApplyRecord: 'Check Application History',
      applyAgain: 'Apply Again',
      onlinePayFinished: 'Successful',
      onlinePayUnFinished: 'Failure',
      bankName: 'Bank Name: ',
      bankAddress: 'Bank Address: ',
      bankAccountName: 'Account Name: ',
      bankAccountNo: 'Account No.: ',
      bankTransferPurpose: 'The Purpose of remittance: ',
      validate: {
        pleaseChoosePayType: 'Please Choose Mode of Payment',
        pleaseInputReceiptTitle: 'Please Input the Title of the Receipt'
      }
    },
    applyList: {
      applyRecord: 'Application History',
      applyNo: 'Application No.',
      applyStatus: 'Application Status',
      applyStatusOptions: {
        all: 'ALL',
        draft: 'Draft',
        toBePaid: 'To be Paid',
        certBeingIssued: 'Processing',
        certIssued: 'Certificate Issued',
        partlyReceived: 'Partly Pick-Up',
        finished: 'Finished',
        cancelled: 'Cancelled',
        notIssued: 'Unable Issue'
      },
      applyType: 'Application Type',
      applyTypeOptions: {
        all: 'ALL',
        paper: 'Paper',
        electronic: 'Electronic'
      },
      columns: {
        applyNo: 'Application No.',
        applyTime: 'Application Time',
        applyType: 'Application Type',
        chargeAmount: 'Fees',
        applyStatus: 'Application Status',
        payType: 'Mode of Payment',
        payStatus: 'Payment Status',
        operation: 'Operation'
      },
      payType: {
        cash: 'Cash Pay',
        bankTransfer: 'Bank Transfer',
        online: 'Online Pay'
      },
      payStatus: {
        noNeedConfirm: 'No Need',
        toBeConfirmed: 'To be Confirmed',
        paid: 'Paid',
        failed: 'Payment Failed'
      },
      operations: {
        uploadBankTransferVoucher: 'Upload Bank Transfer Voucher',
        startOnlinePay: 'Continue Pay',
        continueApply: 'Continue Application',
        cancelApply: 'Cancel',
        checkDetail: 'Detail',
        downloadElectronicVersionFile: 'Download Certificate',
        unableIssue: 'Unable issue'
      },
      pleaseUploadBankTransferVoucher: 'Please Upload Bank Transfer Voucher, Support Common Image File Formats(jpg/jpeg/png)',
      uploadSuccess: 'Upload Success, Please Wait Patience For Review',
      confirmCancelApply: 'Are You Sure to Cancel This Application？',
      confirmCashPay: 'Confirm Cash Pay',
      confirmUseCashPay: 'Confirm Using Cash Payment? We will Charge You When You/Your Assignee Pick-Up Onsite',
      electronicReceiptFile: 'Electronic Receipt File',
      receiptTitle: 'Receipt Title',
      receiptFileName: 'File Name',
      receiptFileNotUpload: 'Receipt not uploaded'
    },
    applyDetail: {
      title: 'Application Detail',
      applyNo: 'Application No.: ',
      applyTime: 'Apply Date：',
      applyDetail: 'Detail',
      certType: 'Certificate Type',
      certName: 'Certificate Name',
      copyNumber: 'Copies',
      operation: 'Operation',
      downloadElectronicVersionFile: 'Download',
      chargeDetail: 'Charging Detail',
      chargeItem: 'Charging Item',
      chargeItemCount: 'Charging Count',
      chargeAmount: 'Amount',
      sumAmount: 'Sum Amount',
      chargeCurrency: 'Currency',
      payType: 'Mode of Payment',
      payTime: 'Payment Time',
      bankTransferVoucher: 'Bank Transfer Voucher',
      noBankTransferVoucher: 'Transfer voucher has not been uploaded yet',
      packageStatusName: 'Package Status',
      principalName: 'Assignee Name',
      principalRelation: 'Relationship',
      principalMobile: 'Assignee Mobile',
      receiveTime: 'Pick-Up Time',
      expectedReceiveTime: 'Expected Pick-Up Date',
      mailStatusName: 'Mail Status',
      mailTrackingNo: 'Mail Tracking No.',
      mailAreaTypeName: 'Mailing Area',
      mailArea: 'Country/Region',
      city: 'City',
      mailZipCode: 'Zip Code',
      mailAddress: 'Address',
      mailSendTime: 'Sent Time',
      packageStatus: {
        draft: 'Draft',
        certBeingIssued: 'Processing',
        certIssued: 'Certificate Issued',
        received: 'Picked-Up'
      },
      mailStatus: {
        noNeed: 'No Need',
        notSent: 'Not Sent',
        sent: 'Sent'
      },
      mailAreaType: {
        domestic: 'Chinese Mainland',
        international: 'Overseas',
        hkMacaoTw: 'Hong Kong, Macao and Taiwan'
      },
      mailConsignee: 'Consignee Name',
      mailConsigneePhone: 'Consignee Phone',
      mailCompany: 'Mail Company',
      issuedTime: 'Issued Time'
    }
  }
}
